/*
  MotorLens motion: scroll reveals, scroll-linked before/after, light parallax.
  No libraries. Content is visible without JS; html.ml-motion is only added when motion is allowed.
  Respects prefers-reduced-motion: reveals show immediately, nothing moves with scroll.
*/
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  // Reveal on scroll: [data-ml-reveal] gets .is-in once 15% of it is visible
  const revealObserver = reduce || !('IntersectionObserver' in window) ? null : new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });

  // Scroll-linked elements: progress 0..1 through their section, written to --ml-p
  const tracked = new Set();
  let ticking = false;

  const update = () => {
    ticking = false;
    const vh = window.innerHeight;
    tracked.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      let p;
      if (el.hasAttribute('data-ml-scrub')) {
        // Sticky scrub sections: 0 when the section top hits the top of the viewport, 1 at its end
        const span = rect.height - vh;
        p = span > 0 ? -rect.top / span : 0;
      } else {
        // Parallax: 0 entering at the bottom, 1 leaving at the top
        p = (vh - rect.top) / (vh + rect.height);
      }
      el.style.setProperty('--ml-p', Math.min(1, Math.max(0, p)).toFixed(4));
    });
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  const init = (scope = document) => {
    if (reduce) {
      // Rest each scrubbed section at a readable state (data-ml-rest, default halfway)
      scope.querySelectorAll('[data-ml-scrub]').forEach((el) => el.style.setProperty('--ml-p', el.dataset.mlRest || '0.5'));
      return;
    }
    root.classList.add('ml-motion');
    scope.querySelectorAll('[data-ml-reveal]').forEach((el) => revealObserver && revealObserver.observe(el));
    scope.querySelectorAll('[data-ml-scrub], [data-ml-parallax]').forEach((el) => tracked.add(el));
    update();
  };

  if (!reduce) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  // Product rail arrows
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ml-rail-step]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    if (!rail) return;
    const card = rail.querySelector(':scope > *');
    const step = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: step * Number(button.dataset.mlRailStep), behavior: reduce ? 'auto' : 'smooth' });
  });

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
